import React from 'react';
import styles from './styles.cssm';

export const LeftStars = () => (
  <div className={`${styles.starsImage} ${styles.leftStars}`} />
);
export const RightStars = () => (
  <div className={`${styles.starsImage} ${styles.rightStars}`} />
);
